export const navLinks = [
  {
    id: 1,
    href: "/",
    name: "Beranda",
    subLinks: [],
  },
  {
    id: 2,
    href: "",
    name: "Layanan",
    headerIcon: "Dashboard",
    subLinks: [
      {
        id: 9,
        href: "/pelatihan",
        name: "Pelatihan",
        desc: "Daftar dan ikuti berbagai pelatihan kami",
        icon: "GraduationCap",
      },
      {
        id: 10,
        href: "/cek-sertifikat",
        name: "Cek Sertifikat",
        desc: "Verifikasi sertifikat pelatihan Anda",
        icon: "Certificate",
      },
      // {
      //   id: 22,
      //   href: "https://simkeu.bppptegal.id/display",
      //   name: "Dashboard Layanan",
      //   desc: "Pantau data layanan secara real-time",
      //   icon: "Dashboard",
      // },
      {
        id: 23,
        href: "https://admin.bppptegal.id",
        name: "Admin Silangit",
        desc: "Portal manajemen sistem terintegrasi",
        icon: "Admin",
      },
      {
        id: 24,
        href: "https://simkeu.bppptegal.id",
        name: "Simkeu",
        desc: "Sistem informasi manajemen keuangan",
        icon: "Wallet",
      },
      {
        id: 25,
        href: "/grafik",
        name: "Grafik Statistik",
        desc: "Statistik penyebaran alumni dan peserta",
        icon: "Dashboard",
      },

      {
        id: 26,
        href: "/daftar-mitra",
        name: "Daftar Mitra & PKS",
        desc: "Lihat daftar perjanjian kerjasama (PKS)",
        icon: "Buildings",
      },
    ],
  },
  {
    id: 4,
    href: "",
    name: "Dukungan lainnya",
    headerIcon: "LifeRing",
    subLinks: [
      {
        id: 5,
        href: "/tes-buta-warna",
        name: "Tes Buta Warna",
        desc: "Uji penglihatan warna Anda secara mandiri",
        icon: "Eye",
      },
      {
        id: 6,
        href: "/persiapan-pelatihan",
        name: "Persiapan Pelatihan",
        desc: "Panduan persiapan sebelum mulai pelatihan",
        icon: "Briefcase",
      },
      // {
      //   id: 7,
      //   href: "/kontak",
      //   name: "Kontak Kami",
      //   desc: "Hubungi tim dukungan kami",
      //   icon: "Phone",
      // },
      {
        id: 20,
        href: "/tarif-layanan",
        name: "Tarif Layanan",
        desc: "Informasi biaya layanan resmi kami",
        icon: "Money",
      },
      {
        id: 21,
        href: "/panduan-mendaftar",
        name: "Tata Cara Mendaftar",
        desc: "Langkah-langkah pendaftaran akun",
        icon: "ClipboardList",
      },
    ],
  },
  {
    id: 8,
    href: "",
    name: "Tentang Kami",
    headerIcon: "InfoCircle",
    subLinks: [
      {
        id: 30,
        href: "/visi-misi",
        name: "Motto",
        desc: "Motto dan visi misi balai pelatihan",
        icon: "Bullseye",
      },
      {
        id: 31,
        href: "/profil-balai",
        name: "Profil Balai",
        desc: "Kenali lebih dekat balai pelatihan kami",
        icon: "Building",
      },
      {
        id: 32,
        href: "/struktur-balai",
        name: "Struktur Organisasi",
        desc: "Struktur kepengurusan balai kami",
        icon: "Sitemap",
      },
    ],
  },
]

export const secondNavlinks = navLinks.map((link) => {
  if (link.subLinks) {
    return {
      ...link,
      id: link.id + 10,
      subLinks: link.subLinks.map((sublink) => {
        return { ...sublink, id: sublink.id + 10 }
      }),
    }
  } else {
    return { ...link, id: link.id + 10 }
  }
})

export const testNavLinks = [
  {
    id: 10,
    href: "/",
    name: "Beranda",
    subLinks: [],
  },
  {
    id: 11,
    href: "",
    name: "Layanan",
    headerIcon: "Dashboard",
    subLinks: [
      {
        id: 18,
        href: "/pelatihan",
        name: "Pelatihan",
        desc: "Daftar dan ikuti berbagai pelatihan kami",
        icon: "GraduationCap",
      },
      {
        id: 19,
        href: "/cek-sertifikat",
        name: "Cek Sertifikat",
        desc: "Verifikasi sertifikat pelatihan Anda",
        icon: "Certificate",
      },
      {
        id: 25,
        href: "https://simkeu.bppptegal.id/display",
        name: "Dashboard Layanan",
        desc: "Pantau data layanan secara real-time",
        icon: "Dashboard",
      },
      {
        id: 26,
        href: "https://admin.bppptegal.id",
        name: "Admin Silangit",
        desc: "Portal manajemen sistem terintegrasi",
        icon: "Admin",
      },
      {
        id: 27,
        href: "https://simkeu.bppptegal.id",
        name: "Simkeu",
        desc: "Sistem informasi manajemen keuangan",
        icon: "Wallet",
      },
      {
        id: 29,
        href: "/grafik",
        name: "Grafik Statistik",
        desc: "Statistik penyebaran alumni dan peserta",
        icon: "Dashboard",
      },
    ],
  },
  {
    id: 13,
    href: "",
    name: "Dukungan lainnya",
    headerIcon: "LifeRing",
    subLinks: [
      {
        id: 14,
        href: "/tes-buta-warna",
        name: "Tes Buta Warna",
        desc: "Uji penglihatan warna Anda secara mandiri",
        icon: "Eye",
      },
      {
        id: 15,
        href: "/persiapan-pelatihan",
        name: "Persiapan Pelatihan",
        desc: "Panduan persiapan sebelum mulai pelatihan",
        icon: "Briefcase",
      },
      // {
      //   id: 16,
      //   href: "/kontak",
      //   name: "Kontak",
      //   desc: "Hubungi tim dukungan kami",
      //   icon: "Phone",
      // },
      {
        id: 21,
        href: "/tarif-layanan",
        name: "Tarif Layanan",
        desc: "Informasi biaya layanan resmi kami",
        icon: "Money",
      },
      {
        id: 28,
        href: "/panduan-mendaftar",
        name: "Tata Cara Mendaftar",
        desc: "Langkah-langkah pendaftaran akun",
        icon: "ClipboardList",
      },
    ],
  },
  {
    id: 17,
    href: "",
    name: "Tentang Kami",
    headerIcon: "InfoCircle",
    subLinks: [
      {
        id: 33,
        href: "/visi-misi",
        name: "Motto",
        desc: "Motto dan visi misi balai pelatihan",
        icon: "Bullseye",
      },
      {
        id: 34,
        href: "/profil-balai",
        name: "Profil Balai",
        desc: "Kenali lebih dekat balai pelatihan kami",
        icon: "Building",
      },
      {
        id: 35,
        href: "/struktur-balai",
        name: "Struktur Organisasi",
        desc: "Struktur kepengurusan balai kami",
        icon: "Sitemap",
      },
    ],
  },
]

export const footerLinks = [
  {
    id: 1,
    href: "/",
    name: "Beranda",
  },
  {
    id: 2,
    href: "/pelatihan",
    name: "Pelatihan",
  },
  {
    id: 3,
    href: "/tentang-kami",
    name: "Tentang Kami",
  },
  {
    id: 4,
    href: "/cek-sertifikat",
    name: "Cek Sertifikat",
  },
  // {
  //   id: 5,
  //   href: "/kontak",
  //   name: "Kontak",
  // },
  {
    id: 6,
    href: "/tarif-layanan",
    name: "Tarif Layanan",
  },
]
